export default {
      id: "Icon--flag-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--flag",
      toString: function () {
        return this.url;
      }
    }